const initialState = {
  data: [],
  project: {},
};

function exam(state = initialState, action) {
  switch (action.type) {
    case "SET_DATA":
      return { ...state, data: action.data };
    case "SET_PROJECT":
      return { ...state, project: action.project.project };
    case "SET_MEDIASTREAM":
      return { ...state, mediaStream: action.data.stream };
    case "RESET_APP":
      return initialState;
    default:
      return state;
  }
}

export default exam;
